<template>
  <Dialog
    header="Dados da fatura"
    style="width: 500px"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :modal="true"
    :closable="false"
  >
    <AppForm
      ref="form"
      :rules="rules"
      :values="invoice"
      v-slot:default="{ formErrors }"
    >
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-md-6">
          <AppFormItem label="Valor" :error="formErrors.billValue">
            <InputNumber
              v-model="invoice.billValue"
              mode="currency"
              currency="BRL"
              locale="pt-BR"
            />
          </AppFormItem>
        </div>

        <div class="p-field p-md-6">
          <AppFormItem label="Data de Vencimento" :error="formErrors.dueDate">
            <Calendar
              v-model="invoice.dueDate"
              dateFormat="dd/mm/yy"
              showIcon
              :monthNavigator="true"
              :yearNavigator="true"
              :yearRange="dateRange"
              :locale="$locales.calendar.ptBR"
              appendTo="body"
            />
          </AppFormItem>
        </div>

        <div class="p-field p-md-6">
          <AppFormItem :error="formErrors.name" label="Link de Pagamento">
            <InputText v-model="invoice.paymentLink" />
          </AppFormItem>
        </div>

        <div class="p-field p-md-6">
          <AppFormItem label="Data do Pagamento" :error="formErrors.paidDate">
            <Calendar
              v-model="invoice.paidDate"
              dateFormat="dd/mm/yy"
              showIcon
              :monthNavigator="true"
              :yearNavigator="true"
              :yearRange="dateRange"
              :locale="$locales.calendar.ptBR"
              appendTo="body"
            />
          </AppFormItem>
        </div>

        <div class="p-field p-md-12">
          <AppFormItem label="Observações">
            <Textarea v-model="invoice.observation" rows="3" />
          </AppFormItem>
        </div>
      </div>
    </AppForm>

    <template #footer>
      <Button
        label="Cancelar"
        class="p-button-outlined p-mr-2"
        @click="cancel()"
      />
      <Button label="Salvar" @click="save()" />
    </template>
  </Dialog>
</template>

<script>
const defaultData = {
  billValue: null,
  dueDate: null,
  paymentLink: '',
  paidDate: null,
  observation: '',
};

export default {
  name: 'InvoiceDialog',
  props: {
    visible: Boolean,
  },
  data() {
    return {
      rules: {
        billValue: [{ required: true, message: 'Informe o valor.' }],
        dueDate: [{ required: true, message: 'Informe a data.' }],
      },
      invoice: {
        ...defaultData,
      },
      dateRange: `${this.$dayjs()
        .subtract(1, 'y')
        .format('YYYY')}:${this.$dayjs().add(1, 'y').format('YYYY')}`,
    };
  },
  methods: {
    setData(data) {
      this.invoice = {
        ...data,
        dueDate: data.dueDate ? new Date(data.dueDate) : null,
        paidDate: data.paidDate ? new Date(data.paidDate) : null,
      };
    },
    reset() {
      this.invoice = { ...defaultData };
    },
    cancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.reset();
    },
    async save() {
      if (!(await this.$refs.form.validate())) {
        return;
      }
      this.$emit('update:visible', false);
      this.$emit('save', { data: this.invoice });
      this.reset();
    },
  },
};
</script>

<style>
</style>
